import { useRef } from 'react';
import type { FC } from 'react';
import './styles.css';
import { prop } from '@ipfabric/utils/fp/prop';
import { toggleLoadViewDialog } from 'components/Graph/commands/toggleLoadViewDialog';
import { selectHasLoadableViews } from 'components/Graph/model/selectors/selectHasLoadableViews';
import { useLocale } from 'containers/App/LocaleContext';
import { useGraphContextSelectors } from '../GraphContext';
import { FileIcon } from '../GraphSidePanel/icons/FileIcon';
import { GraphToolbarButton } from '../GraphToolbar/GraphToolbarButton';
import { GraphLoadViewDropdown } from './GraphLoadViewDropdown';

export const GraphLoadView: FC = () => {
  const msg = useLocale();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
    hasLoadableViews: selectHasLoadableViews,
    open: prop('loadViewDialog', 'open'),
  });

  const close = () => {
    ctxProps.dispatch(toggleLoadViewDialog, { open: false });
  };

  const toggleOpen = () => {
    ctxProps.dispatch(toggleLoadViewDialog);
  };

  return (
    <div ref={wrapperRef}>
      <GraphToolbarButton
        disabled={!ctxProps.hasLoadableViews}
        onClick={toggleOpen}
        title={msg.canvasGraph.commands.loadView.selectView}
      >
        <FileIcon
          title={msg.canvasGraph.commands.loadView.selectView}
          height={13}
          width={16}
        />
      </GraphToolbarButton>
      {ctxProps.open && (
        <GraphLoadViewDropdown onClose={close} wrapperRef={wrapperRef} />
      )}
    </div>
  );
};
